import './Overlay.css';
export var overlayCSS = '_76w12x0-2-0-1';